import React from 'react';
import Proptypes from 'prop-types';
import { Table, Radio } from 'react-bootstrap';
import _ from 'lodash';
import { getFramesSortedByFileName } from '../../helpers/Saxs/SaxsFramesHelper';
import { FRAME_SCALE_LOG, FRAME_SCALE_LINEAR } from '../../constants/saxs';
import { getFileName } from '../../helpers/Saxs/SaxsGeneralHelper';

class FrameListTable extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let { frames, selectedFrames, onRowClicked } = this.props;
        return (<Table striped hover condensed>
            <thead>
                <tr>
                    <th style={{ textAlign: 'center' }}>
                        <span > Scale : </span>
                        <Radio checked={this.props.scale === FRAME_SCALE_LOG ? true : false} inline onChange={() => this.props.onScaleChanged(FRAME_SCALE_LOG)}> Log </Radio>
                        <Radio checked={this.props.scale === FRAME_SCALE_LINEAR ? true : false} inline onChange={() => this.props.onScaleChanged(FRAME_SCALE_LINEAR)}> Linear </Radio>
                    </th>
                </tr>
            </thead>
            <tbody>
                {frames.map((frame, index) => {
                    return (<tr
                        key={index}
                        className={_.find(selectedFrames, selectedFrame => selectedFrame.frameId === frame.frameId && selectedFrame.type === frame.type) ? 'info' : null}
                        onClick={() => onRowClicked(frame.frameId, frame.type)}>
                        <td>
                            {getFileName(frame.filePath, true)} {frame.discarded === true ? <span style={{ color: 'red' }}>(Discarded)</span> : null}
                        </td>
                    </tr>)
                }
                )}
            </tbody>
        </Table>);
    }
}

export default FrameListTable;

FrameListTable.proptypes = {
    /** frame list */
    frames: Proptypes.array,

    onScaleChanged: Proptypes.func,
    /** Callback function triggered when the user clicks a row */
    onRowClicked: Proptypes.func,

    scale: Proptypes.string,

}


// WEBPACK FOOTER //
// ./src/components/saxs/FrameListTable.js